import { useTranslation } from "react-i18next"

import { BarChart3, Lightbulb, Target, TrendingUp } from "@/components/icons"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function AIPortfolioGettingStartedPage() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-portfolio.getting-started" })

  const features = [
    { icon: Lightbulb, key: "ideation" },
    { icon: Target, key: "use_cases" },
    { icon: BarChart3, key: "roi" },
    { icon: TrendingUp, key: "tracking" },
  ] as const

  return (
    <CourseLayout>
      <CourseSection>
        <h1>{t("title")}</h1>
        <p>{t("intro")}</p>
      </CourseSection>

      <CourseSection>
        <h2>{t("what_is.title")}</h2>
        <p>{t("what_is.description")}</p>

        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {features.map(({ icon: Icon, key }) => (
            <Card key={key}>
              <CardHeader className="flex-row items-center gap-3 pb-2">
                <div className="bg-primary/10 text-primary flex h-9 w-9 shrink-0 items-center justify-center rounded-lg">
                  <Icon className="h-4 w-4" />
                </div>
                <h3 className="text-sm font-semibold">{t(`features.${key}.title`)}</h3>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">{t(`features.${key}.description`)}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </CourseSection>

      <CourseSection>
        <h2>{t("example.title")}</h2>
        <div className="bg-muted/30 rounded-xl border p-5">
          <p className="mb-2 text-sm font-semibold">{t("example.scenario_title")}</p>
          <p className="text-muted-foreground text-sm">{t("example.scenario")}</p>
          <ul className="mt-3 list-inside list-disc space-y-1 text-sm">
            {ensureArray<string>(t("example.steps", { returnObjects: true })).map((step, i) => (
              <li key={i}>{step}</li>
            ))}
          </ul>
        </div>
      </CourseSection>

      <CourseSection>
        <h2>{t("summary.title")}</h2>
        <ul className="list-inside list-disc space-y-1 text-sm">
          {ensureArray<string>(t("summary.points", { returnObjects: true })).map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </CourseSection>
    </CourseLayout>
  )
}
